import { AuthGuard } from '@auth';
import { useUserProfile } from '@hooks';
import { Dashboard, ProfilePageWrapper } from '@profile';

export default function Profile() {
  const profile = useUserProfile();

  return (
    <ProfilePageWrapper pageTitle="Profile">
      <AuthGuard>{profile && <Dashboard profile={profile} />}</AuthGuard>
    </ProfilePageWrapper>
  );
}
